import { render, staticRenderFns } from "./PendingFieldsPanel.vue?vue&type=template&id=53cb6197&scoped=true"
import script from "./PendingFieldsPanel.vue?vue&type=script&lang=js"
export * from "./PendingFieldsPanel.vue?vue&type=script&lang=js"
import style0 from "./PendingFieldsPanel.vue?vue&type=style&index=0&id=53cb6197&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cb6197",
  null
  
)

export default component.exports